//img
import { API_KEY } from "../../../../chatbotKey.js";
import Images from "../../../assets/img/images.js";

const Contact = () => {
  return (
    <section id="landingContact" class="section-py bg-body landing-contact">
      <div class="container">
        <div class="text-center mb-4">
          <span class="badge bg-label-primary">Contact US</span>
        </div>
        <h4 class="text-center mb-1">
          <span class="position-relative fw-extrabold z-1 px-2">
            Let's work
            <img
              src={Images.sectionTitleIcon}
              alt="laptop charging"
              class="section-title-img position-absolute object-fit-contain bottom-0 z-n1"
            />
          </span>
          together
        </h4>
        <p class="text-center mb-12 pb-md-4">
          Any question or remark? just write us a message
        </p>
        <div class="row g-6">
          <div class="col-lg-5">
            <div class="contact-img-box position-relative border p-2 h-100">
              <img
                src={Images.contactBorder}
                alt="contact border"
                class="contact-border-img position-absolute d-none d-lg-block scaleX-n1-rtl"
              />
              <img
                src={Images.contactCustomerService}
                alt="contact customer service"
                class="contact-img w-100 scaleX-n1-rtl"
              />
              <div class="p-4 pb-2">
                <div class="row g-4">
                  <div class="col-md-6 col-lg-12 col-xl-6">
                    <div class="d-flex align-items-center">
                      <div class="badge bg-label-primary rounded p-1_5 me-3">
                        <i class="icon-base bx bx-envelope icon-lg"></i>
                      </div>
                      <div>
                        <p class="mb-0">Email</p>
                        <h6 class="mb-0">
                          <a
                            href="mailto:example@gmail.com"
                            class="text-heading"
                          >
                            daihoc.hcm@fpt.edu.vn
                          </a>
                        </h6>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 col-lg-12 col-xl-6">
                    <div class="d-flex align-items-center">
                      <div class="badge bg-label-success rounded p-1_5 me-3">
                        <i class="icon-base bx bx-phone-call icon-lg"></i>
                      </div>
                      <div>
                        <p class="mb-0">Phone</p>
                        <h6 class="mb-0">
                          <a href="tel:+1234-568-963" class="text-heading">
                            (028) 7300 5588
                          </a>
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-7">
            <div class="card h-100">
              <div class="card-body">
                <h4 class="mb-2">Send a message</h4>
                <p class="mb-6">
                  If you would like to discuss anything related to payment,
                  account, licensing,
                  <br class="d-none d-lg-block" />
                  partnerships, or have pre-sales questions, you’re at the right
                  place.
                </p>
                <form>
                  <div class="row g-4">
                    <div class="col-md-6">
                      <label class="form-label" for="contact-form-fullname">
                        Full Name
                      </label>
                      <input
                        type="text"
                        class="form-control"
                        id="contact-form-fullname"
                        placeholder="john"
                      />
                    </div>
                    <div class="col-md-6">
                      <label class="form-label" for="contact-form-email">
                        Email
                      </label>
                      <input
                        type="text"
                        id="contact-form-email"
                        class="form-control"
                        placeholder="johndoe@gmail.com"
                      />
                    </div>
                    <div class="col-12">
                      <label class="form-label" for="contact-form-message">
                        Message
                      </label>
                      <textarea
                        id="contact-form-message"
                        class="form-control"
                        rows="11"
                        placeholder="Write a message"
                      ></textarea>
                    </div>
                    <div class="col-12">
                      <button type="submit" class="btn btn-primary">
                        Send inquiry
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
